















































import { KeywordsInput } from '../../components';

import { CrudFormMixin } from '../../mixins/crud-form.mixin';

import { ROUTER_CONSTS } from '../../router/router.consts';

import SynonymsForm from '../synonyms/synonyms-form.view.vue';

export default {
  name: 'synonyms-dashboard-form',
  mixins: [SynonymsForm],
  components: {
    KeywordsInput
  },
  computed: {
    valid: function (): boolean {
      if (!this.item.type) {
        return false;
      }
      if (!this.item.filters.lang) {
        return false;
      }
      if (!this.item.synonyms.length || this.item.synonyms.length < 2) {
        return false;
      }
      return true;
    }
  },
  data: function () {
    return {
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.synonymsDashboard.update)
    };
  },
  methods: {
    onAccept: function () {
      // Using the new synonyms as a mixin, merges the "data". So hyponyms is still inside this.item even if you try to override it
      // Trying to make the POST with any parameter that doesn't exist in the model (such as hyponyms for the old play), it will crash.
      delete this.item.hyponyms;
      CrudFormMixin.methods.onAccept.bind(this)();
    }
  }
};
